<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="项目列表"
    width="70%"
  >
    <div>
      <el-table
        :data="assignmentList"
        :header-cell-style="{textAlign:'center'}"
        :cell-style="{textAlign:'center'}">
        <el-table-column label="封面">
          <template slot-scope="scope">
            <img v-if="scope.row.coverUrl" :src="scope.row.coverUrl" style="width: 140px;height: 80px;border: none"/>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" width="220"></el-table-column>
        <el-table-column label="项目名称" prop="projectName"></el-table-column>
        <el-table-column label="省市">
          <template slot-scope="scope">
            {{ scope.row.province }}{{ scope.row.city }}
          </template>
        </el-table-column>
        <el-table-column label="商机号" prop="quote"></el-table-column>
        <el-table-column label="创建时间" width="170">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatter }}
          </template>
        </el-table-column>
        <el-table-column width="230" label="操作">
          <template slot-scope="scope">
            <el-button pain type="text" @click="goRelevance(scope.$index)">关联项目</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandleHis"
        @current-change="currentChangeHandleHis"
        :current-page.sync="pageNum"
        :page-sizes="[5, 20, 50, 100]"
        :page-size.sync="pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="text-align: right;padding-bottom: 20px;margin: 25px 50px">
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";

export default {
  name: "Assignment",
  data(){
    return{
      assignmentList:[],
      pageNum:1,
      pageSize:10,
      total:0,
      dialogVisible:false
    }
  },
  mounted() {
    this.getList()
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
  methods:{
    getDialog(){
      this.dialogVisible = true
    },
    getList(){
      this.$request.projectList(this.pageNum,this.pageSize).then(res=>{
        console.log(res,'任务列表')
        this.assignmentList = res.data.records
        this.total = res.data.total
      })
    },
    goRelevance(index){
      // console.log(this.$store.state.taskId,111)
      const data = {
        taskId: this.$store.state.taskId, //任务id
        projectId: this.$store.state.projectId, //后台导入项目id
        businessOpportunityId: this.assignmentList[index].id //前台商机项目id
      }
      this.$request.getRelevance([data]).then(res=>{
        this.$message.success('关联成功')
        this.dialogVisible = false
        this.getList()
        window.location.onload()
      })
    },
    sizeChangeHandleHis() {
      this.getList()
    },
    // 当前页
    currentChangeHandleHis() {
      this.getList()
    },
  }
}
</script>

<style scoped>

</style>
